import script from "./Botbar.vue?vue&type=script&lang=js"
export * from "./Botbar.vue?vue&type=script&lang=js"

import "./Botbar.vue?vue&type=style&index=0&id=d8d3f154&lang=css"

const __exports__ = script;

export default __exports__